module.exports = __webpack_public_path__ + "static/media/mercedes.72365e0d.jpg";